import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../api';
import teaser_bg from '../../../../assets/images/deals/teaser_bg.png';
import { RootState } from '../../../../store/rootReducer';
import LinkButton from '../../../common/LinkButton';
import MessageActions from '../../../message/redux/actions';
import FileView from '../../Investments/modal/FileView';
import { DataRoom } from '../redux/types';

const Teaser: React.FC = () => {
    const dispatch = useDispatch();
    const teaser = useSelector((state: RootState) => state.deal.teaser);

    const [loading, setLoading] = useState(false);

    const onClickDownload = (data: DataRoom) => {
        setLoading(true);
        Apis.downloadDataRoomDocument(data.dealUUID, data.uuid, data.uuid, 'Teasers')
            .then((response) => {
                try {
                    let file = new Blob([response.data], { type: response.headers['content-type'] });
                    let fileURL = window.URL.createObjectURL(file);
                    let a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = fileURL;
                    a.download = data.name;
                    a.click();
                    window.URL.revokeObjectURL(fileURL);
                } catch (err) {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                }
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {teaser.length > 0 && (
                <div className="flex justify-between items-center bg-[#F1F7FF] md:ml-4">
                    <div className="px-6 flex flex-col gap-2 justify-center">
                        <div className="pt-[8px]">
                            <p className="font-[WorkSans-Bold] font-bold text-[#0F2240] text-lg uppercase">Teaser</p>
                            <p className="font-[Lato] text-sm text-[#20222B]">
                                Access to the printable deal presentation
                            </p>
                        </div>
                        <div className="flex gap-1 items-center">
                            <LinkButton
                                onClick={() => {
                                    if (!loading) onClickDownload(teaser[0]);
                                }}
                                title={'Download'}
                                isArrow
                                loading={loading}
                                size="sm"
                            />
                            <FileView
                                docUUID={teaser[0].uuid}
                                fileName={teaser[0].name}
                                pageType="dataRoom"
                                dealUUID={teaser[0].dealUUID}
                                rootUUID={teaser[0].parentUUID || teaser[0].uuid}
                                list={teaser}
                                group={teaser[0].group}
                            />
                        </div>
                    </div>
                    <img src={teaser_bg} width="100px" height={'150px'} alt="teaser" />
                </div>
            )}
        </>
    );
};

export default Teaser;
